import { useAuth0 } from '@auth0/auth0-react';

import { BroadcastChannel } from 'broadcast-channel';
import { useAuthSlice } from '@restore/auth/auth.slice';
import { useExternalUserViewSlice } from '@restore/ExternalUserView/externalUserView.slice';

const logoutChannel = new BroadcastChannel('logout');

enum LogOutMessageTypes {
  LOG_OUT = 'LOG_OUT',
}

export const useLogout = () => {
  const { logout } = useAuth0();
  const clearUser = useAuthSlice((state, actions) => actions.clearUser);
  const resetView = useExternalUserViewSlice((state, actions) => actions.resetView);

  const clearAppSession = async () => {
    await logoutChannel.postMessage(LogOutMessageTypes.LOG_OUT);
    clearUser();
    resetView();
  };

  const logoutUser = async () => {
    await clearAppSession();
    await logout({ logoutParams: { returnTo: window.location.origin } });
  };

  const logoutLocally = async () => {
    await clearAppSession();
    await logout({ openUrl: false });
  };

  logoutChannel.onmessage = async () => {
    window.location.reload();
    await logoutChannel.close();
  };

  return { logout: logoutUser, logoutLocally };
};
